import { ChevronRight, AlertCircle, CheckCircle2, FileText } from "lucide-react";
import { fmtMoney } from "../../lib/billsLanguage";

const fmtDate = (d) => {
  if (!d) return "No date";
  const t = new Date(`${d}T00:00:00`);
  return Number.isNaN(t.getTime()) ? d : t.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

const Status = ({ bill }) => {
  if (bill.status === "CONFIRMED")
    return <span className="inline-flex items-center gap-1 text-[13px] text-[#2f5d3a]"><CheckCircle2 size={15} aria-hidden />Confirmed</span>;
  if (bill.attention)
    return (
      <span className="flex flex-col">
        <span className="inline-flex items-center gap-1 text-[13px] font-semibold text-amber-800"><AlertCircle size={15} aria-hidden />Needs attention</span>
        <span className="text-[13px] text-amber-900" data-testid={`bill-card-attention-${bill.bill_id}`}>{bill.attention.label}</span>
      </span>
    );
  return <span className="inline-flex items-center gap-1 text-[13px] text-archival-secondary"><FileText size={15} aria-hidden />Draft · ready to confirm</span>;
};

// Compact, one-hand bill card. Tapping opens the existing Bill Review (drafts) or the read-only detail (confirmed).
export const BillListCard = ({ bill, onOpen }) => (
  <li>
    <button type="button" onClick={() => onOpen(bill)} data-testid={`bill-card-${bill.bill_id}`} data-status={bill.status}
      className={`w-full text-left rounded-md border bg-white p-4 min-h-[88px] flex items-center gap-3 transition-colors hover:bg-[#fbfaf7] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--action)] ${
        bill.attention ? "border-amber-300 border-l-4" : "border-[#E4E0D8]"}`}>
      <span className="flex-1 min-w-0">
        <span className="flex items-baseline justify-between gap-3">
          <span className="text-[16px] font-semibold text-archival-primary truncate" data-testid={`bill-card-vendor-${bill.bill_id}`}>{bill.vendor_name || "Unknown vendor"}</span>
          <span className="text-[16px] font-semibold tabular-nums text-archival-primary shrink-0">{fmtMoney(bill.total_amount)}</span>
        </span>
        <span className="block mt-0.5 text-[13px] text-archival-secondary truncate">
          <span data-testid={`bill-card-number-${bill.bill_id}`}>{bill.bill_number || "No bill number"}</span> · {fmtDate(bill.bill_date)} · {bill.item_count} {bill.item_count === 1 ? "item" : "items"}
        </span>
        <span className="block mt-2"><Status bill={bill} /></span>
      </span>
      <ChevronRight size={18} className="text-archival-muted shrink-0" aria-hidden />
    </button>
  </li>
);

export { fmtDate };
